// extracted by mini-css-extract-plugin
module.exports = {"root":"Contact_root__Bje4V","content":"Contact_content__uqZQN","itemText":"Contact_itemText__2i5uW"};